import React, { useEffect, useState, useRef } from "react";
import UserPhoneVerify from "../../util/UserPhoneVerify";
import { useLockFn } from "ahooks";
import general from "../../../general";
import Dialog from "../../../lib/Dialog";
import ImagePicker from "../../util/ImageTradePicker";
import { CSSTransition } from "react-transition-group";
import useUrlState from "@ahooksjs/use-url-state";
import useActiveState from "../../../lib/useActiveState";
import { useHistory } from "react-router-dom";
import { sessionLocal } from "../../util/storage";

export default (props) => {
  const history = useHistory();
  const [params, setParams] = useUrlState({}, { navigateMode: "replace" });
  const [user] = useActiveState("user");
  const [data, setData] = useState({
    game_uploadedshots: [],
    sell_price: "",
    total_pay_amount: undefined,
    title: "",
    content: "",
    second_level_pwd: "",
    server_name: "",
    xh_username: "",
    recycle_type: "",
    trade_type: "",
    game_id: "",
    isUpdate: null,
  });
  const [imgs, setImgs] = useState([]);
  const [games, setGames] = useState([]);

  let [existImgs, setExistImgs] = useState([]);

  useEffect(async () => {
    if (params?.secondTrade) {
      console.log("触发啦");

      await gameLoad();
      let tradeInfo = sessionLocal.get("tradeInfo");
      setData({
        game_uploadedshots: [],
        sell_price: tradeInfo.sell_price ? String(tradeInfo.sell_price) : "",
        total_pay_amount: Number(tradeInfo.xh_recharge_money),
        title: tradeInfo.title || "",
        content: tradeInfo.content || "",
        second_level_pwd: tradeInfo.second_level_pwd || "",
        server_name: tradeInfo.server_name || "",
        xh_username: tradeInfo.xh_username || "",
        recycle_type: tradeInfo.recycle_type || "",
        trade_type: tradeInfo.trade_type || "",
        game_id: tradeInfo.game_id || "",
        isUpdate: tradeInfo.isUpdate,
      });
      existImgs = [...tradeInfo.game_imgs];
      setExistImgs(existImgs);

      console.log("data----", tradeInfo, existImgs);
    } else {
      setData({
        game_uploadedshots: [],
        sell_price: "",
        total_pay_amount: undefined,
        title: "",
        content: "",
        second_level_pwd: "",
        server_name: "",
        xh_username: "",
        recycle_type: "",
        trade_type: "",
        game_id: "",
        isUpdate: null,
      });
      setExistImgs([]);
      setImgs([]);
    }
  }, [params?.secondTrade]);

  const gameLoad = useLockFn(async () => {
    Dialog.loading();

    await general.axios
      .post("v3/base/game/getSelfGameList", {
        pagination: { count: 1000, page: 1 },
      })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setGames(data.game_list || []);
        }
      })
      .catch((err) => {
        Dialog.error("tradedGameList " + err.message);
      });
  });

  useEffect(() => {
    gameLoad();
  }, []);

  const [alts, setAlts] = useState([]);
  const altLoad = useLockFn(async () => {
    if (!data.game_id) {
      Dialog.error("请先选择游戏");
      return;
    }
    Dialog.loading();
    await general.axios
      .post("/v3/base/game/getSelfXhUserNameList", {
        game_id: data.game_id,
        pagination: { count: 917917, page: 1 },
      })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setAlts(data.xh_list);
        }
      })
      .catch((err) => {
        Dialog.error("getSelfXhUserNameList " + err.message);
      });
  });
  useEffect(() => {
    if (data.game_id) {
      altLoad();
    } else {
      setAlts([]);
    }
  }, [data.game_id]);

  const recoveryTypeList = [
    {
      label: "官方回收",
      value: "1",
    },
    {
      label: "试玩回收",
      value: "2",
    },
  ];

  const [showTransactionType, setShowTransactionType] = useState(false);
  const transactionTypeList = [
    {
      label: "官方交易号",
      value: "1",
    },
    {
      label: "超级捡漏号",
      value: "2",
    },
    {
      label: "开局号",
      value: "3",
    },
  ];

  const [confirm, setConfirm] = useState(true);
  const [confirmed, setConfirmed] = useState(false);

  const [verify, setVerify] = useState();
  const submit = useLockFn(async () => {
    console.log("要提交的数据----", data);

    if (!data.game_id) {
      Dialog.error("请先选择游戏");
      return;
    }

    if (!data.xh_username) {
      Dialog.error("请先选择小号");
      return;
    }

    if (!data.server_name) {
      Dialog.error("请输入游戏区服");
      return;
    }

    if (
      data.sell_price === "" ||
      data.sell_price === null ||
      data.sell_price === undefined
    ) {
      Dialog.error("请输入出售价");
      return;
    }

    if (user.member_name != "guanfangjiaoyi") {
      if (!data.sell_price || Number(data.sell_price) < 1) {
        Dialog.error("出售价不能低于1元");
        return;
      }
    }

    if (Number(data.sell_price) > data?.total_pay_amount) {
      Dialog.error(`出售价不能大于实际累充金额${data?.total_pay_amount}元`);
      return;
    }

    if (user.member_name == "guanfangjiaoyi" && !data.trade_type) {
      Dialog.error("请选择交易号类型");
      return;
    }

    if (!data.title) {
      Dialog.error("请输入标题");
      return;
    }

    if (imgs.length + existImgs.length < 3) {
      Dialog.info("请至少上传三张图片");
      return;
    }

    if (!verify) {
      if (!user.mobile) {
        Dialog.confirm({
          title: "没有绑定手机号，现在去绑定？",
          yes: () => {
            history.push("/user/phone");
          },
        });
        return;
      }
      setVerify(true);
      return;
    }

    Dialog.info("开始图片上传");
    setData({ ...data, game_uploadedshots: [] });
    let uploadedShots = [];
    for (let i = 0; i < imgs.length; i++) {
      let formData = new FormData();
      formData.append("type", "trade");
      formData.append("imageData", imgs[i].file);
      try {
        const res = await general.axios.post(
          "/v3/user/trade/uploadImagePublicOss",
          formData,
        );
        let { status, data: result } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          uploadedShots.push(result.imageUrl);
          // 使用循环索引 + 1 来显示进度，更可靠
          const currentCount = i + 1;
          // 先关闭之前的提示
          Dialog.close();

          // 显示新的进度
          Dialog.info("上传图片" + currentCount + "/" + imgs.length);
        }
      } catch (e) {
        Dialog.error(e.message);
        return;
      }
    }

    data.game_uploadedshots = [...uploadedShots];
    setData({ ...data });

    if (data.isUpdate) {
      data.game_uploadedshots = [...data.game_uploadedshots, ...existImgs];
      setData({ ...data });
    }

    console.log("要提交的数据----", data);

    let formData = new FormData();
    for (let name in data) {
      if (name === "game_uploadedshots") {
        for (let i = 0; i < data[name].length; i++) {
          formData.append(name + "[]", data[name][i]);
        }
      } else {
        formData.append(name, data[name]);
      }
    }

    Dialog.loading("正在提交");
    await general.axios
      .post("/v3/user/trade/submitTradeDetail", formData)
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let { status } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          Dialog.success("提交成功", () => {
            setVerify(false);
            // history.goBack();
            setData({
              game_uploadedshots: [],
              sell_price: "",
              total_pay_amount: undefined,
              title: "",
              content: "",
              second_level_pwd: "",
              server_name: "",
              xh_username: "",
              recycle_type: "",
              trade_type: "",
              game_id: "",
              isUpdate: null,
            });
            setExistImgs([]);
            setImgs([]);

            gameLoad();
          });
        }
      })
      .catch((err) => {
        Dialog.error("submitTradeDetail " + err.message);
      });
  });

  const [showGameList, setShowGameList] = useState(false);
  const [showAltList, setShowAltList] = useState(false);
  const gameListRef = useRef(null);
  const altListRef = useRef(null);
  const transactionTypeRef = useRef(null);

  // 点击外部区域关闭下拉菜单
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        gameListRef.current &&
        !gameListRef.current.contains(event.target) &&
        altListRef.current &&
        !altListRef.current.contains(event.target) &&
        transactionTypeRef.current &&
        !transactionTypeRef.current.contains(event.target)
      ) {
        setShowGameList(false);
        setShowAltList(false);
        setShowTransactionType(false);
      }
    };

    if (showGameList || showAltList || showTransactionType) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showGameList, showAltList, showTransactionType]);

  useEffect(() => {
    if (confirm) {
      // iOS Safari 兼容处理：同时设置 html 和 body
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.height = "100%";
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    }
    // 清理函数：组件卸载时恢复样式
    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    };
  }, [confirm, props.active]);

  return (
    <div className="trade-submit">
      <div className="trade-body">
        <div className="trade-submit-info">
          <div
            className="trade-input"
            style={{ position: "relative" }}
            ref={gameListRef}
          >
            <div className="name">选择游戏</div>

            <div
              className="value"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
              onClick={() => {
                setShowGameList(!showGameList);
                setShowAltList(false);
                setShowTransactionType(false);
              }}
            >
              {games.find((game) => game.game_id === data.game_id)?.game_name ||
                "选择"}
              <img
                style={{
                  width: "0.16rem",
                  height: "0.16rem",
                  marginLeft: "4px",
                }}
                src="/resources/four-three/trade/arrow.png"
                alt=""
              />
            </div>

            <div className={`game-list ${!showGameList ? "hidden" : ""}`}>
              <div
                className={`game-item ${!data.game_id ? "active" : ""}`}
                onClick={() => {
                  setData({ ...data, game_id: "" });
                  setShowGameList(false);
                }}
              >
                {!data.game_id && (
                  <img src="/resources/four-three/trade/selected.png" alt="" />
                )}
                <div className="game-item-name">请选择</div>
              </div>
              {games.map((game) => (
                <div
                  key={game.game_id}
                  className={`game-item ${
                    data.game_id === game.game_id ? "active" : ""
                  }`}
                  onClick={() => {
                    setData({ ...data, game_id: game.game_id });
                    setShowGameList(false);
                  }}
                >
                  {data.game_id === game.game_id && (
                    <img
                      src="/resources/four-three/trade/selected.png"
                      alt=""
                    />
                  )}
                  <div className="game-item-name">{game.game_name}</div>
                </div>
              ))}
            </div>
          </div>

          <div
            className="trade-input"
            style={{ position: "relative" }}
            ref={altListRef}
          >
            <div className="name">选择小号</div>

            <div
              className="value"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
              onClick={() => {
                setShowGameList(false);
                setShowTransactionType(false);

                if (!data.game_id) {
                  Dialog.error("请先选择游戏");
                  return;
                }
                if (alts.length == 0) {
                  Dialog.error("该游戏无可出售小号");
                  return;
                }
                setShowAltList(!showAltList);
              }}
            >
              {alts.find((alt) => alt.xh_username === data.xh_username)
                ?.xh_alias || "选择"}
              <img
                style={{
                  width: "0.16rem",
                  height: "0.16rem",
                  marginLeft: "4px",
                }}
                src="/resources/four-three/trade/arrow.png"
                alt=""
              />
            </div>

            <div className={`game-list ${!showAltList ? "hidden" : ""}`}>
              <div
                className={`game-item ${!data.xh_username ? "active" : ""}`}
                onClick={() => {
                  setData({
                    ...data,
                    xh_username: "",
                    total_pay_amount: undefined,
                    recycle_type: "",
                  });
                  setShowAltList(false);
                }}
              >
                {!data.xh_username && (
                  <img src="/resources/four-three/trade/selected.png" alt="" />
                )}
                <div className="game-item-name">请选择</div>
              </div>
              {alts.map((alt) => (
                <div
                  key={alt.xh_username}
                  className={`game-item ${
                    data.xh_username === alt.xh_username ? "active" : ""
                  }`}
                  onClick={() => {
                    setData({
                      ...data,
                      xh_username: alt.xh_username,
                      total_pay_amount: Number(alt.total_pay_amount),
                      recycle_type: alt.recycle_type,
                    });
                    setShowAltList(false);
                  }}
                >
                  {data.xh_username === alt.xh_username && (
                    <img
                      src="/resources/four-three/trade/selected.png"
                      alt=""
                    />
                  )}
                  <div className="game-item-name">{alt.xh_alias}</div>
                </div>
              ))}
            </div>
          </div>

          {user.member_name == "guanfangjiaoyi" && (
            <div className="trade-input" style={{ position: "relative" }}>
              <div className="name">回收类型</div>

              <div className="value">
                {recoveryTypeList.find(
                  (item) => item.value === data.recycle_type,
                )?.label || ""}
              </div>
            </div>
          )}

          <div className="trade-input">
            <div className="name">游戏区服</div>
            <div className="value">
              <input
                type="text"
                placeholder="请输入游戏区服"
                value={data.server_name}
                onChange={(e) =>
                  setData({ ...data, server_name: e.target.value })
                }
              />
            </div>
          </div>

          <div className="trade-input">
            <div className="name">出售价</div>

            <div className="value">
              <input
                type="number"
                min={user.member_name == "guanfangjiaoyi" ? 0 : 1}
                placeholder={
                  user.member_name == "guanfangjiaoyi"
                    ? "不低于0元"
                    : "不低于1元"
                }
                value={data.sell_price || ""}
                onChange={(e) => {
                  let value = e.target.value;
                  // 只允许正整数：移除所有非数字字符，如果为空则允许，否则确保是正整数
                  if (value === "") {
                    setData({ ...data, sell_price: "" });
                  } else {
                    // 移除所有非数字字符
                    let numValue = value.replace(/[^\d]/g, "");
                    // 如果处理后的值不为空，设置为该值
                    if (numValue !== "") {
                      setData({ ...data, sell_price: numValue });
                    }
                  }
                }}
              />
            </div>
          </div>

          <div
            className="trade-input"
            style={{
              borderBottom:
                user.member_name == "guanfangjiaoyi"
                  ? "1px solid #eee"
                  : "none",
            }}
          >
            <div className="name">
              出售可得<span>（手续费5%）</span>
            </div>

            <div className="value">
              {(() => {
                let value = (Number(data.sell_price) || 0) * 10;
                let fee = value * 0.05;
                return value - fee || 0;
              })()}
              平台币
            </div>
          </div>

          {user.member_name == "guanfangjiaoyi" && (
            <div
              className="trade-input"
              style={{ position: "relative" }}
              ref={transactionTypeRef}
            >
              <div className="name">交易号类型</div>

              <div
                className="value"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
                onClick={() => {
                  setShowTransactionType(!showTransactionType);
                  setShowGameList(false);
                  setShowAltList(false);
                }}
              >
                {transactionTypeList.find(
                  (item) => item.value === data.trade_type,
                )?.label || "选择"}
                <img
                  style={{
                    width: "0.16rem",
                    height: "0.16rem",
                    marginLeft: "4px",
                  }}
                  src="/resources/four-three/trade/arrow.png"
                  alt=""
                />
              </div>

              <div
                className={`game-list ${!showTransactionType ? "hidden" : ""}`}
              >
                <div
                  className={`game-item ${!data.trade_type ? "active" : ""}`}
                  onClick={() => {
                    setData({
                      ...data,
                      trade_type: "",
                      total_pay_amount: undefined,
                    });
                    setShowTransactionType(false);
                  }}
                >
                  {!data.trade_type && (
                    <img
                      src="/resources/four-three/trade/selected.png"
                      alt=""
                    />
                  )}
                  <div className="game-item-name">请选择</div>
                </div>
                {transactionTypeList.map((item) => (
                  <div
                    key={item.value}
                    className={`game-item ${
                      data.trade_type === item.value ? "active" : ""
                    }`}
                    onClick={() => {
                      setData({
                        ...data,
                        trade_type: item.value,
                      });
                      setShowTransactionType(false);
                    }}
                  >
                    {data.trade_type === item.value && (
                      <img
                        src="/resources/four-three/trade/selected.png"
                        alt=""
                      />
                    )}
                    <div className="game-item-name">{item.label}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="trade-submit-info">
          <div className="trade-input">
            <div className="name">标题</div>

            <div className="value">
              <input
                type="text"
                placeholder="请输入标题"
                value={data.title}
                onChange={(e) => setData({ ...data, title: e.target.value })}
              />
            </div>
          </div>
          <div className="trade-input develop">
            <div className="name">商品描述（选填）</div>

            <div className="value">
              <textarea
                rows="3"
                placeholder="可描述角色等级、装备、属性，完善的描述可快速有效促 成交易。"
                value={data.content}
                onChange={(e) => setData({ ...data, content: e.target.value })}
              />
            </div>
          </div>
          <div className="trade-input develop">
            <div className="name">二级密码（有则必填）</div>

            <div className="value">
              <input
                type="text"
                placeholder="例如：仓库密码。此密码仅审核人员及最终买家可见；"
                value={data.second_level_pwd}
                onChange={(e) =>
                  setData({ ...data, second_level_pwd: e.target.value })
                }
              />
            </div>
          </div>
          <div className="trade-input develop" style={{ borderBottom: "none" }}>
            <div className="name">上传图片 请上传3-5张游戏截图</div>

            <div className="value" style={{ marginTop: "2px" }}>
              <ImagePicker
                multiple={true}
                max={5}
                files={imgs}
                setFiles={setImgs}
                existImgs={existImgs}
                setExistImgs={setExistImgs}
              />
            </div>
          </div>
          <div className="trade-tips">
            <p>
              <span>温馨提示：</span>
              亲爱的玩家，为了快速审核交易信息，请上传以下截图：人物属性界面、VIP充值等级或特权界面、背包仓库或宠物属性界面。禁止上传个人账号相关信息。
            </p>
            <p>
              <span>备注：</span>
              由于游戏排行榜会因为时间关系导致最终排行误差，为避免造成买卖双方纠纷，上传排行描述及相关截图的一律不通过审核！
            </p>
          </div>
        </div>

        <div className="trade-operate">
          <div className="btn" onClick={submit}>
            确认出售
          </div>
        </div>
      </div>

      <CSSTransition
        in={confirm}
        timeout={250}
        appear={true}
        unmountOnExit={true}
      >
        <div className="trade-confirm">
          <div className="container">
            <div className="head">
              <div className="title">出售须知</div>

              <img
                style={{ width: "20px", height: "20px" }}
                src="/resources/four-three/trade/close.png"
                alt=""
                onClick={() => {
                  setConfirm(false);
                }}
              />
            </div>
            <div className="main">
              <div className="title">出售流程</div>

              <div className="process">
                <ul className="process-list">
                  <li className="process-num">1</li>
                  <li className="process-line"></li>
                  <li className="process-num">2</li>
                  <li className="process-line"></li>
                  <li className="process-num">3</li>
                  <li className="process-line"></li>
                  <li className="process-num">4</li>
                </ul>
                <ul className="process-list">
                  <li className="process-text">上传商品</li>
                  <li className="process-text">审核冻结</li>
                  <li className="process-text">买家购买</li>
                  <li className="process-text">出售成功</li>
                </ul>
              </div>

              <div className="title">卖家须知</div>
              <div className="body" style={{ maxHeight: "40vh" }}>
                <p>
                  提出出售申请后，待售小号在游戏中所有区服的角色都将被冻结待售，无法登录。
                </p>
                <p>审核不成功或您选择下架商品，可重新登录游戏获得小号。</p>
                <p>
                  出售时显示累计金额为该小号在该游戏同一小号下多个区服的角色所有的实际充值（微信/支付宝/平台币）。
                </p>
                <p>
                  小号出售成功后，该小号在本游戏中所有区服的角色会一同售出，但不影响该小号在其他游戏中的角色。
                </p>
                <p>
                  出售成功将收取5%的手续费，剩余收益以平台币形式转至您的账号下。平台币不可提现，仅能用于游戏充值。
                </p>
                <p>交易完成后，不支持找回。</p>

                <p>
                  当游戏发布停服公告或游戏问题临时下架后，该游戏的小号不论是否上架都将无法交易，且该游戏已经上架的小号将自动下架。
                </p>
                <p>
                  卖家需保证所有提供信息属实，因虚假信息导致的纠纷，由卖家承担责任。
                </p>
                <p>
                  卖家须知：因卖家出售过程中操作失误产生的一切损失，由卖家自行承担，平台概不负责。
                </p>
              </div>
            </div>
            <div className="operate">
              <div className="input" onClick={() => setConfirmed(true)}>
                <img
                  src={
                    confirmed
                      ? "/resources/four-three/trade/radio-selected.png"
                      : "/resources/four-three/trade/radio.png"
                  }
                  alt=""
                />
                我已阅读
              </div>

              <div
                className={"buy" + (!confirmed ? " disable" : "")}
                onClick={() => confirmed && setConfirm(false)}
              >
                我知道了
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>

      <UserPhoneVerify
        show={verify}
        type="06"
        close={() => setVerify(false)}
        onSuccess={submit}
      />
    </div>
  );
};
